import { Icon } from '@iconify/react';
import { ReactNode, MouseEvent } from 'react';

import { Popover } from 'components/data-display/Popover';
import { Button } from 'components/general/Button';

interface ChatSettingsProps {
  threadId: string;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onPin: (threadId: string) => void;
  onRename: (threadId: string) => void;
  onDelete: (threadId: string) => void;
  isPinned: boolean;
  children: ReactNode;
}

export function ChatSettings({
  threadId,
  isOpen,
  onOpenChange,
  onPin,
  onRename,
  onDelete,
  isPinned,
  children,
}: ChatSettingsProps) {
  const handlePin = (e: MouseEvent, threadId: string) => {
    e.preventDefault();
    e.stopPropagation();
    onPin(threadId);
    onOpenChange(false);
  };

  const handleRename = (e: MouseEvent, threadId: string) => {
    e.preventDefault();
    e.stopPropagation();
    onRename(threadId);
    onOpenChange(false);
  };

  const handleDelete = (e: MouseEvent, threadId: string) => {
    e.preventDefault();
    e.stopPropagation();
    onDelete(threadId);
    onOpenChange(false);
  };

  return (
    <Popover
      content={
        <div className="w-40 p-1 flex flex-col">
          <Button
            type="text"
            className="w-full justify-start px-3 py-2 text-sm hover:bg-color-control-item-bg-hover hover:border-transparent"
            onClick={(e) => handlePin(e, threadId)}
            icon={
              <Icon
                icon={
                  isPinned
                    ? 'ant-design:pushpin-filled'
                    : 'ant-design:pushpin-outlined'
                }
                className="w-4 h-4"
              />
            }
          >
            {isPinned ? 'Unpin' : 'Pin'}
          </Button>
          <Button
            type="text"
            className="w-full justify-start px-3 py-2 text-sm hover:bg-color-control-item-bg-hover hover:border-transparent"
            onClick={(e) => handleRename(e, threadId)}
            icon={<Icon icon="ant-design:edit-outlined" className="w-4 h-4" />}
          >
            Rename
          </Button>
          <Button
            type="text"
            className="w-full justify-start px-3 py-2 text-sm hover:bg-color-control-item-bg-hover hover:border-transparent"
            onClick={(e) => handleDelete(e, threadId)}
            icon={
              <Icon icon="ant-design:delete-outlined" className="w-4 h-4" />
            }
          >
            Delete
          </Button>
        </div>
      }
      trigger="click"
      open={isOpen}
      onOpenChange={onOpenChange}
      placement="rightTop"
      arrow={false}
    >
      {children}
    </Popover>
  );
}
